import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { LessonList } from './LessonList'
import { LessonCoursesReport } from './LessonCoursesReport'

const StudentLessons = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id
	const [activeTab, setActiveTab] = useState('listOfCourses')

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab)
	}

	return (
		<StudentTopMenuLayout activeMenu="Lessons" pageName="Lessons">
			<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
				<div className="card-body">
					<Nav tabs>
						<NavItem>
							<NavLink
								className={activeTab === 'listOfCourses' ? 'active' : ''}
								onClick={() => toggle('listOfCourses')}
								style={{ cursor: 'pointer' }}
							>
								List of Courses
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={activeTab === 'courseReport' ? 'active' : ''}
								onClick={() => toggle('courseReport')}
								style={{ cursor: 'pointer' }}
							>
								Course Report
							</NavLink>
						</NavItem>
					</Nav>

					<TabContent activeTab={activeTab} className="mt-3">
						<TabPane tabId="listOfCourses">
							<LessonList studentId={effectiveStudentId} isStudent={!isInstructorView} />
						</TabPane>
						<TabPane tabId="courseReport">
							<LessonCoursesReport studentId={effectiveStudentId} />
						</TabPane>
					</TabContent>
				</div>
			</div>
		</StudentTopMenuLayout>
	)
}

export { StudentLessons }
